module.exports = __webpack_public_path__ + "static/logo-lg-0c6e81081df20656f20dc7b465025cfc.jpg";